import Authenticate from "./bootstrap/authenticate";

import ConfigLoader from "./bootstrap/config-loader"

import AppLoader from './bootstrap/app-loader'

import GoogleTagManager from "./bootstrap/google-tag-manager";

import Header from "./bootstrap/header";

import Sidebar from "./bootstrap/sidebar";

import Cookies from 'js-cookie';

import Axios from 'axios';

import en from './lang/en.json';
import no from './lang/no.json';

const localMessages = { en, no };

import { initAppBridge } from "./bridge/bridge";
import REGISTRY from "./bridge/registry";

export default {

    async init() {

        await Authenticate.init();

        await ConfigLoader.init(Cookies.get('profile'), Cookies.get('bs_token'));

        let lang = Cookies.get('bs_language')

        try {
            // MUST run before injecting app scripts
            initAppBridge(REGISTRY, { strict: false });
        } catch {
            //
        }

        // expose the AppLoader.loadSubApp so that other app can trigger loading app
        window.loadSubApp = AppLoader.loadSubApp.bind(AppLoader);

        AppLoader.run(location.pathname + location.hash, window.brandsafe_app_config, lang);

        let messages = {}

        const apiTranslations = await this.initLanguage(lang);
        messages[lang] = { ...(localMessages[lang] || {}), ...apiTranslations };

        //Bootstrap the header
        Header.init(messages, lang);

        //Bootstrap the sidebar
        Sidebar.init(window.brandsafe_app_config, messages, lang);

        GoogleTagManager.init();

    },

    async initLanguage(language) {
        try {
            let token = Cookies.get('bs_token');
            const response = await Axios.get('https://api.brandsafe.no/v1/config/translations/wrapper/' + language, {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            });

            return response.data;
        } catch (error) {
            return {};
        }
    }
}
